'use strict';

require("core-js/modules/es.array.flat.js");

var implementation = require('./implementation');

module.exports = function getPolyfill() {
  return Array.prototype.flat || implementation;
};